module.exports = __webpack_public_path__ + "img/backhoe_driving.51a176d4.svg";